import { Route, Routes } from 'react-router-dom';
import { Home } from './routes/Home';
import { Login } from './routes/Login';
import { Me } from './routes/Me';
import { HistoryList } from './routes/HistoryList';
import { HistoryDetail } from './routes/HistoryDetail';
import { StyleGuide } from './routes/StyleGuide';
import { AdminHome } from './routes/admin/AdminHome';
import { AdminUsers } from './routes/admin/AdminUsers';
import { AdminExport } from './routes/admin/Export';
import { TournamentNew } from './routes/admin/TournamentNew';
import { TournamentManage } from './routes/admin/TournamentManage';
import { TournamentActive } from './routes/tournament/Active';
import { TournamentJoin } from './routes/tournament/Join';
import { SubmitScore } from './routes/tournament/SubmitScore';
import { Leaderboard } from './routes/tournament/Leaderboard';
import { AdminGuard } from './components/AdminGuard';
import { PlayerGuard } from './components/PlayerGuard';
import { NavLayout } from './components/NavLayout';
import { FloatingHelp } from './components/FloatingHelp';

const admin = (el: React.ReactNode) => <NavLayout><AdminGuard>{el}</AdminGuard></NavLayout>;
const player = (el: React.ReactNode) => <NavLayout><PlayerGuard>{el}</PlayerGuard></NavLayout>;
const nav = (el: React.ReactNode) => <NavLayout>{el}</NavLayout>;

export function App() {
  return (
    <>
      {/* Floating top-right help icon — renders on every route, outside
          any nav row. Modal copy switches based on route (/login vs the
          rest). Lives here so it can never compete with the marquee chip
          for nav width. */}
      <FloatingHelp />
      <Routes>
      {/* /login intentionally has NO TopNav — it's the auth flow surface */}
      <Route path="/login" element={<Login />} />

      <Route path="/" element={nav(<Home />)} />
      <Route path="/me" element={nav(<Me />)} />
      <Route path="/history" element={player(<HistoryList />)} />
      <Route path="/history/:id" element={player(<HistoryDetail />)} />
      <Route path="/style-guide" element={nav(<StyleGuide />)} />

      <Route path="/tournament/active" element={player(<TournamentActive />)} />
      <Route
        path="/tournament/active/leaderboard"
        element={player(<Leaderboard />)}
      />
      <Route path="/tournament/active/join" element={player(<TournamentJoin />)} />
      <Route
        path="/tournament/active/submit/:entryId"
        element={player(<SubmitScore />)}
      />

      <Route path="/admin" element={admin(<AdminHome />)} />
      <Route path="/admin/users" element={admin(<AdminUsers />)} />
      <Route path="/admin/export" element={admin(<AdminExport />)} />
      <Route path="/admin/tournament/new" element={admin(<TournamentNew />)} />
      <Route
        path="/admin/tournament/:id/manage"
        element={admin(<TournamentManage />)}
      />

      <Route path="*" element={nav(<Home />)} />
      </Routes>
    </>
  );
}
